module.exports = __webpack_public_path__ + "static/media/Decisions_Step1_Image5c.09b9a855.jpg";